import { useState } from 'react'
import { Copy, Textarea } from '../../../../elements'

function validateJSONConfig(json: string) {
  try {
    JSON.parse(json)
    return true
  } catch {
    return false
  }
}

type CustomFormProps = {
  data: Record<string, any>
  setData: React.Dispatch<React.SetStateAction<Record<string, any>>>
  readonly?: boolean
  onChange?: ({ data, errors }: { data: Record<string, any>; errors: any }) => void
  webhookUrl?: string
}

export const CustomForm = ({ webhookUrl, data, setData, readonly }: CustomFormProps) => {
  const [integrationConfig, setIntegrationConfig] = useState(JSON.stringify(data ?? {}, undefined, 2))
  const isConfigValid = validateJSONConfig(integrationConfig)

  const updateConfig = () => {
    if (!isConfigValid) {
      return
    }
    setData(JSON.parse(integrationConfig) ?? {})
  }

  return (
    <div className="grid gap-2">
      {webhookUrl ? (
        <Copy label="Webhook URL" value={webhookUrl} description="Webhook URL" />
      ) : (
        <div className="text-center">
          <p className="text-sm text-gray-11">Enable the channel first to continue with the next step</p>
        </div>
      )}
      <Textarea
        label="Configuration (JSON)"
        disabled={readonly}
        invalid={!isConfigValid}
        onChange={(e) => setIntegrationConfig(e.target.value)}
        value={integrationConfig}
        onBlur={() => updateConfig()}
      />
    </div>
  )
}
